(function ($) {
    const format = function (d) {
        let lang = navigator.language || 'default'

        if (!app.data['localise-months'][lang] ||
            !app.data['localise-ampm'][lang] ||
            !app.data['localise-datetime-format'][lang]) {
                lang = "en-AU"
        }

        const localiseMonths = app.data['localise-months'][lang] 
        const localiseAmPm = app.data['localise-ampm'][lang]
        const localiseDateTimeFormat = app.data['localise-datetime-format'][lang]
        
        const p2 = (n) => String(n).padStart(2,'0')
        
        const dx = {
            dd : d.getDate(),
            mmm : localiseMonths[d.getMonth()-1],
            yyyy : d.getFullYear(),
            hh : d.getHours() - (d.getHours() > 12 ? 12 : 0),
            mm : p2(d.getMinutes()),
            tt : d.getHours() < 12 ? localiseAmPm['am'] : localiseAmPm['pm']
        }
        
        const entries = Object.entries(dx);
        const applyFormat = function (s) {
            for (const [k,v] of entries) {
                if (s.replaceAll(k,v) !== s) {
                    return applyFormat(s.replaceAll(k,v));
                }
            }
            return s;
        }
        
        return applyFormat(localiseDateTimeFormat);
    }
    
    $(document).ready(function () {
        if (app && app.data && app.data['localise-data']) {
            for (const [elem,lookup] of Object.entries(app.data['localise-data'])) {
                if (lookup && lookup['utc']) {
                    for (const ds of lookup['utc'])
                    {
                        const d = new Date(ds)
                        $('#' + elem + ' :contains("'+ds+ '")').each((_,e) => {
                            $(e).html($(e).html().replace(ds,format(d)));
                        });
                    }
                }           
            }
        }
    });
})(jQuery);
